// import 'bootstrap-vue-next/dist/bootstrap-vue-next.css?inline'
// import 'bootstrap/dist/css/bootstrap.min.css?inline'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import './styles.scss'

import {defineCustomElement} from 'vue';
import SearchCe from "@/components/Search.ce.vue";

const simple_websocket_chat = defineCustomElement(SearchCe, {
    shadowRoot: false
});

customElements.define('search-assistant-webchat', simple_websocket_chat);
